import React, { useState } from 'react';
import { FiFilter, FiX, FiDollarSign, FiStar, FiCalendar } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const AdvancedFilters = ({
  isOpen,
  onToggle,
  minPrice,
  maxPrice,
  minRating,
  onMinPriceChange,
  onMaxPriceChange,
  onMinRatingChange,
  onReset
}) => {
  return (
    <>
      <button
        onClick={onToggle}
        className="flex items-center gap-2 px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg hover:bg-gray-700 transition-colors text-sm font-medium"
      >
        <FiFilter className="w-4 h-4" />
        Filtres avancés
        {(minPrice || maxPrice || minRating) && (
          <span className="bg-amber-500 text-white text-xs px-2 py-0.5 rounded-full">
            {(minPrice ? 1 : 0) + (maxPrice ? 1 : 0) + (minRating ? 1 : 0)}
          </span>
        )}
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden bg-gray-800/50 border border-gray-700 rounded-xl p-4 mt-4"
          >
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* Prix minimum */}
              <div>
                <label className="block text-sm text-gray-400 mb-2 flex items-center gap-2">
                  <FiDollarSign className="w-4 h-4" />
                  Prix minimum
                </label>
                <input
                  type="number"
                  value={minPrice || ''}
                  onChange={(e) => onMinPriceChange(e.target.value ? Number(e.target.value) : null)}
                  placeholder="Min"
                  className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white focus:ring-2 focus:ring-amber-500"
                />
              </div>

              {/* Prix maximum */}
              <div>
                <label className="block text-sm text-gray-400 mb-2 flex items-center gap-2">
                  <FiDollarSign className="w-4 h-4" />
                  Prix maximum
                </label>
                <input
                  type="number"
                  value={maxPrice || ''}
                  onChange={(e) => onMaxPriceChange(e.target.value ? Number(e.target.value) : null)}
                  placeholder="Max"
                  className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white focus:ring-2 focus:ring-amber-500"
                />
              </div>

              {/* Note minimum */}
              <div>
                <label className="block text-sm text-gray-400 mb-2 flex items-center gap-2">
                  <FiStar className="w-4 h-4" />
                  Note minimum
                </label>
                <div className="flex items-center gap-2">
                  <input
                    type="range"
                    min="0"
                    max="5"
                    step="0.5"
                    value={minRating || 0}
                    onChange={(e) => onMinRatingChange(Number(e.target.value))}
                    className="flex-1"
                  />
                  <span className="text-sm text-gray-300 w-12">{minRating || 0}★</span>
                </div>
              </div>
            </div>

            {/* Bouton réinitialiser */}
            {(minPrice || maxPrice || minRating) && (
              <button
                onClick={onReset}
                className="mt-4 text-sm text-gray-400 hover:text-white flex items-center gap-2"
              >
                <FiX className="w-4 h-4" />
                Réinitialiser les filtres
              </button>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default AdvancedFilters;





